import React, { useEffect, useState } from 'react';
import { NavigationContainer, DefaultTheme, DarkTheme } from '@react-navigation/native';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase';
import { MainNavigator } from './MainNavigator';
import { AuthNavigator } from './AuthNavigator';
import { useTheme } from '../context/ThemeContext';
import { useURL, getInitialURL, addEventListener } from 'expo-linking';
import linkingConfig from '../services/linkingConfig';

export function Navigation() {
  const [user, setUser] = useState<any>(null);
  const [initializing, setInitializing] = useState(true);
  const { theme, isDarkMode } = useTheme();
  const url = useURL();
  
  // Crear un tema compatible con NavigationContainer
  const navigationTheme = {
    ...(isDarkMode ? DarkTheme : DefaultTheme),
    colors: {
      ...(isDarkMode ? DarkTheme.colors : DefaultTheme.colors),
      primary: theme.colors.primary,
      background: theme.colors.background,
      card: theme.colors.card,
      text: theme.colors.text,
      border: theme.colors.border,
      notification: theme.colors.error,
    },
  };

  // Manejar enlaces externos e internos
  const handleDeepLink = (event: { url: string }) => {
    console.log('Deeplink detectado:', event.url);
  };

  useEffect(() => {
    // Configuración para manejar deeplinks cuando la app ya está abierta
    const subscription = addEventListener('url', handleDeepLink);

    // Verificar si la app fue abierta con un deeplink
    getInitialURL().then((initialUrl) => {
      if (initialUrl) {
        console.log('App abierta con URL inicial:', initialUrl);
      }
    });

    // Configuración de autenticación
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      if (initializing) setInitializing(false);
    });

    // Limpieza de suscripciones
    return () => {
      subscription.remove();
      unsubscribe();
    };
  }, [initializing]);

  if (initializing) return null;

  // Si hay un url activo, mostrarlo en la consola
  if (url) {
    console.log('URL activo:', url);
  }

  return (
    <NavigationContainer 
      theme={navigationTheme}
      linking={linkingConfig}
    >
      {user ? <MainNavigator /> : <AuthNavigator />}
    </NavigationContainer>
  );
} 